module.exports = __webpack_public_path__ + "static/media/fishes-on-wall-1.77af38c1.png";